import { darken, lighten } from "@mantine/core"

export function rgbaToHex(
  {
    r,
    g,
    b,
    a,
  }: {
    r?: number | undefined
    g?: number | undefined
    b?: number | undefined
    a?: number | undefined
  },
  lightOffset?: number
): string | undefined {
  if (
    r === undefined ||
    g === undefined ||
    b === undefined ||
    a === undefined
  ) {
    return undefined
  }
  // Ensure RGB values are within the 0-255 range
  if (r > 255) r = 255
  if (g > 255) g = 255
  if (b > 255) b = 255
  if (a > 255) a = 255
  if (r < 0) r = 0
  if (g < 0) g = 0
  if (b < 0) b = 0
  if (a < 0) a = 0

  // Convert each component to a 2-digit hexadecimal string
  const hexR = r.toString(16).padStart(2, "0")
  const hexG = g.toString(16).padStart(2, "0")
  const hexB = b.toString(16).padStart(2, "0")
  const hexA = a.toString(16).padStart(2, "0")

  let result = `#${hexR}${hexG}${hexB}${hexA}`

  if (lightOffset) {
    result =
      lightOffset < 0
        ? darken(result, Math.abs(lightOffset))
        : lighten(result, lightOffset)
  }

  // Combine to form the final hex string
  return result
}
